import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi,ReportDto } from '@src/api';

import { reportsStore } from '../reportsStore';

class ReportEditStore {
  report: ReportDto | null;

  isNew = false;

  editMode = false;

  isLoading = false;

  disableEdit = false;

  api: CmApi;

  hiddenEdit = false;

  hiddenDelete = false;

  hiddenClean = false;

  hiddenSave = false;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    this.report = null;

    makeAutoObservable(this);
  }

  get isEditMode() {
    return this.editMode || this.isNew;
  }

  setDisableEdit = (disableEdit = true) => {
    this.disableEdit = disableEdit;
  };

  setNew = (isNew = true) => {
    this.isNew = isNew;
    this.report = null;
  };

  setEditMode = (editMode = true) => {
    this.editMode = editMode;
  };

  save = async (report: ReportDto) => {
    preloaderStore.preloader(true);
    const { data } = await (this.isNew ? this.api.report.addReport(report) : this.api.report.updateReport(report));

    if (data?.code) {
      reportsStore.setIsChanged(true);

      if (this.isNew) {
        preloaderStore.preloader(false);
        return data.code;
      }
      runInAction(() => {
        this.report = data;
        this.setEditMode(false);
      });
    }
    preloaderStore.preloader(false);
    return undefined;
  };

  delete = async () => {
    if (this.report?.code) {
      await this.api.report.deleteReport([this.report.code]);
      reportsStore.setIsChanged(true);
    }
  };

  fetch = async (code?: string): Promise<void> => {
    if (!code) {
      return;
    }
    preloaderStore.preloader(true);
    runInAction(() => {
      this.isLoading = true;
      this.setEditMode(false);
      this.setNew(false);
    });

    const { data } = await this.api.report.getReport(code);

    runInAction(() => {
      this.report = data;
      this.isLoading = false;
    });
    preloaderStore.preloader(false);
  };

  setHiddenEdit = (hiddenEdit = true): void => {
    this.hiddenEdit = hiddenEdit;
  };

  setHiddenDelete = (hiddenDelete = true): void => {
    this.hiddenDelete = hiddenDelete;
  };

  setHiddenClean = (hiddenClean = true): void => {
    this.hiddenClean = hiddenClean;
  };

  setHiddenSave = (hiddenSave = true): void => {
    this.hiddenSave = hiddenSave;
  };
}

export const reportEditStore = new ReportEditStore({ api: cmApi });
